import React, { useEffect, useState } from 'react';
import { Side } from './Side/Side';
import { Contents } from './Contents/Contents';

export const Attendance = () => {
    return(
        <div>
            <Side/>
            <Contents/>
        </div>
    );
};
